export default __webpack_public_path__ + "static/media/Pistol_5.50fd21c2.png";